import { OfferingsSectionStyles } from './offerings.style';

const {
  Section,
  Container,
  TitleContainer,
  Title,
  TitleDesktop,
  ContentContainer,
  Heading,
  Description,
} = OfferingsSectionStyles;

export interface OfferingsSectionProps {
  title: string;
  sections: {
    heading: string;
    description: string;
  }[];
  id?: string;
}

const OfferingsSection = ({ title, sections, id }: OfferingsSectionProps) => {
  return (
    <Section id={id}>
      <Container>
        <TitleContainer>
          <Title as="h2">{title}</Title>
          <TitleDesktop as="h2">{title}</TitleDesktop>
        </TitleContainer>
        {sections.map((section, index) => (
          <ContentContainer key={section.heading}>
            <Heading as="p">{section.heading}</Heading>
            <Description as="p">{section.description}</Description>
          </ContentContainer>
        ))}
      </Container>
    </Section>
  );
};

export default OfferingsSection;
